import { MprcButton, MprcButtonProps } from "components/MprcButton";
import * as React from "react";
import { useMprcTheme } from "../MprcThemeProvider";

export const ButtonClose = React.forwardRef<HTMLButtonElement, MprcButtonProps>(({ text, title, color = "cancel", ...rest }, ref) => {
    const { theme } = useMprcTheme();
    const lText = text || theme.buttons.ButtonClose.text;
    const lTitle = title || theme.buttons.ButtonClose.title;

    return (
        <MprcButton {...rest} ref={ref} title={lTitle} text={lText} color={color} />
    );
});
